var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-icon-btn',{attrs:{"access":_vm.isShowCollectionInfo,"show-tooltip":!_vm.isShowCollectionInfo,"icon-name":"mdi-information-outline","icon-height":"15","bottom":""},on:{"click":_vm.showInfo}},[_vm._v(" Info ")])}
var staticRenderFns = []

export { render, staticRenderFns }